import { tv } from 'tailwind-variants';

export const typographyStyles = tv({
  base: 'text-secondary-two',
  variants: {
    design: {
      external: 'font-inter',
    },
    align: {
      center: 'text-center',
      left: 'text-left',
      right: 'text-right',
    },
    bold: {
      true: 'font-bold',
    },
    italic: {
      true: 'italic',
    },
    underline: {
      true: 'underline',
    },
    textTransform: {
      capitalize: 'capitalize',
      lowercase: 'lowercase',
      uppercase: 'uppercase',
    },
  },
});
